
import { useState, useEffect } from 'react';

import legalRepresentativeServices from '../api/legalRepresentativeServices';

/**
 * Hook personnalisé pour gérer les représentants légaux d'un domaine
 * @param {number} domainId - ID du domaine
 * @returns {Object} États et fonctions pour gérer les représentants
 */
export const useLegalRepresentatives = (domainId) => {
  // États pour les données et le chargement
  const [representatives, setRepresentatives] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // États pour les filtres
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 20,
    search: '',
    hasManagedAccounts: null,
    sortBy: 'ManagedAccountsCount',
    sortOrder: 'desc'
  });

  /**
   * Charger les représentants légaux en fonction des filtres
   */
  const fetchRepresentatives = async () => {
    if (!domainId) return;

    setLoading(true);
    setError(null);

    try {
      const result = await legalRepresentativeServices.getDomainRepresentatives(domainId, filters);
      
      if (result.success) {
        setRepresentatives(result.data);
        setPagination(result.pagination);
      } else {
        setError('Erreur lors du chargement des représentants');
      }
    } catch (err) {
      setError(err.message || 'Erreur de connexion au serveur');
      // console.error('Error fetching representatives:', err);
    } finally {
      setLoading(false);
    }
  };

  // Effet pour recharger les données quand les filtres ou le domaine changent
  useEffect(() => {
    fetchRepresentatives();
  }, [domainId, filters]);

  /**
   * Mettre à jour les filtres
   * @param {Object} newFilters - Nouveaux filtres à appliquer
   */
  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters, page: 1 })); // Reset à la page 1 quand les filtres changent
  };

  return {
    // États
    representatives,
    pagination,
    loading,
    error,
    filters,
    
    // Fonctions
    setFilters: updateFilters,
    refetch: fetchRepresentatives
  };
};